import {
	Button,
	TextField
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import { useActions } from 'kea';

import grouplogic from 'src/store/group';

const empty_group = {
	name: ''
}

const CreateGroupDialog = () => {
	const [open, setOpen] = useState(false);
	const [newGroup, setNewGroup] = useState(empty_group);

	const { create } = useActions(grouplogic);

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
		setNewGroup(empty_group);
	}
	const handleAdd = () => {
		if (newGroup.name) {
			create(newGroup);
			setNewGroup(empty_group);
			setOpen(false);
		}
	}

	const handleChange = (key, value) => {
		let changed_user = { ...newGroup };
		changed_user[key] = value;
		setNewGroup(changed_user);
	}

	return (
		<div style={{ paddingTop: '15px' }}>
			<Button
				color="primary"
				variant="contained"
				aria-label="add"
				onClick={handleClickOpen}
			>
				Create
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Create a new Group
				</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Group Name"
						type="text"
						fullWidth
						error={newGroup.name ? false : true}
						helperText={newGroup.name ? null : 'Invalid'}
						value={newGroup.name}
						onChange={(e) => handleChange('name', e.target.value)}
						inputProps={{
							maxLength: 100
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleAdd} color="primary">
						Create
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default CreateGroupDialog
